import { api, apiPaths } from "../../api";
import {
  AuctionQuestionDTO,
  ConsumerAuctionDTO,
  CreateNegotiationMessageBody,
  NegotiationMessageDTO
} from "../../types/types";

export enum ConsumerQueryKeys {
  AUCTION_NEGOTIATION = "consumer/negotiation",
  AUCTIONS = "consumer/auctions"
}

export const postNegotiationMessage = async (props: {
  message: CreateNegotiationMessageBody;
  auctionId: number;
}): Promise<NegotiationMessageDTO | Error> => {
  const { message, auctionId } = props;
  return api
    .url(`${apiPaths.AUCTIONS}/${auctionId}/negotiations`)
    .post(message)
    .json()
    .then((res) => {
      return res as NegotiationMessageDTO;
    })
    .catch((error) => {
      throw error;
    });
};

export const acceptBidForAuction = async (props: {
  auctionId: number;
  bidId: number;
}): Promise<ConsumerAuctionDTO | Error> => {
  const { bidId, auctionId } = props;
  return api
    .url(`${apiPaths.AUCTIONS}/${auctionId}/offers/${bidId}/accept`)
    .put()
    .json()
    .then((res) => {
      return res as ConsumerAuctionDTO;
    })
    .catch((error) => {
      throw error;
    });
};

interface GetAuctionProps {
  auctionId?: number;
}
export const getAuction = async (
  props: GetAuctionProps
): Promise<ConsumerAuctionDTO> => {
  return api
    .url(`${apiPaths.AUCTIONS}/${props.auctionId}`)
    .get()
    .json()
    .then((res) => {
      return res as ConsumerAuctionDTO;
    })
    .catch(() => {
      return {} as ConsumerAuctionDTO;
    });
};

export const declineBidForAuction = async (props: {
  auctionId: number;
  bidId: number;
}): Promise<ConsumerAuctionDTO | Error> => {
  const { bidId, auctionId } = props;
  return api
    .url(`${apiPaths.AUCTIONS}/${auctionId}/offers/${bidId}/decline`)
    .put()
    .json()
    .then((res) => {
      return res as ConsumerAuctionDTO;
    })
    .catch((error) => {
      throw error;
    });
};

export const republishAuction = async (props: {
  auctionId: number;
}): Promise<ConsumerAuctionDTO | Error> => {
  const { auctionId } = props;
  return api
    .url(`${apiPaths.AUCTIONS}/${auctionId}/copy`)
    .post()
    .json()
    .then((res) => {
      return res as ConsumerAuctionDTO;
    })
    .catch((error) => {
      throw error;
    });
};

export const putQuestionAnswer = async (props: {
  auctionId: number;
  questionId: number;
  answer: string;
}): Promise<AuctionQuestionDTO | Error> => {
  const { questionId, auctionId, answer } = props;
  return api
    .url(`${apiPaths.AUCTIONS}/${auctionId}/questions/${questionId}`)
    .put({ answer: answer })
    .json()
    .then((res) => {
      return res as AuctionQuestionDTO;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteQuestionAnswer = async (props: {
  auctionId: number;
  questionId: number;
  answerId: number;
}): Promise<AuctionQuestionDTO | Error> => {
  const { questionId, auctionId, answerId } = props;
  return api
    .url(
      `${apiPaths.AUCTIONS}/${auctionId}/questions/${questionId}/answer/${answerId}`
    )
    .delete()
    .json()
    .then((res) => {
      return res as AuctionQuestionDTO;
    })
    .catch((error) => {
      throw error;
    });
};

export const declineAllOffersForAuction = async (props: {
  auctionId: number;
}): Promise<ConsumerAuctionDTO | Error> => {
  const { auctionId } = props;
  return api
    .url(`${apiPaths.AUCTIONS}/${auctionId}/offers/decline-all`)
    .put()
    .json()
    .then((res) => {
      return res as ConsumerAuctionDTO;
    })
    .catch((error) => {
      throw error;
    });
};
